import * as React from 'react';
import Layout from '../Layout/Layout';

export default function Questionnaires() {
  return (
    <Layout pageTitle='Questionnaire Manager'>
    </Layout>
  );
}
